import { EmoticonNeutralOutlineIcon } from './EmoticonNeutralOutlineIcon';

/**
 * author: Austin Andrews
 * id 17F30B32-37E2-41BB-876C-70E568D04623
 * name emoticon-neutral-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-neutral-outline.svg
 * tags
 * - Emoji 
 */
export const SmileyNeutralOutlineIcon = EmoticonNeutralOutlineIcon;
export default SmileyNeutralOutlineIcon